function getSubAddress(isOnlyMobile: boolean) {
  const { hostname } = window.location;
  const envSubAddress = process.env.REACT_APP_SUBADDRESS || '';

  if (envSubAddress === 'ROOT_LOCAL') {
    // 서브도메인 방식이면
    if (isOnlyMobile) return hostname.split('.')[0]; // 서브도메인 방식 + 모바일사이트만 허용이면 그냥 앞에꺼 적용
    return hostname.startsWith('m.') // m.으로 시작할 경우
      ? hostname.split('.')[1] // m.을 건너뛰고 다음 원소(문자열)가 서브도메인
      : hostname.split('.')[0]; // m.이 아니니 첫 번쨰 원소가 바로 서브도메인
  }
  return envSubAddress;
}

export default getSubAddress;
